import { render, staticRenderFns } from "./PanelOrganizerHeader.vue?vue&type=template&id=3bcd6921&scoped=true&"
import script from "./PanelOrganizerHeader.vue?vue&type=script&lang=js&"
export * from "./PanelOrganizerHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelOrganizerHeader.vue?vue&type=style&index=0&id=3bcd6921&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd6921",
  null
  
)

export default component.exports